/**
 * @file: TaskFlowStatusType.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum TaskFlowStatusType {
  Started = 'started',
  Finished = 'finished',
  Cancelled = 'cancelled',
}
